<template>
  <div class="p-6 bg-grid-gray">
    <router-view />
    <div class="flex items-start justify-between max-w-lg mx-auto mt-4">
      <div class="w-40">
        <button class="w-full btn btn-link" v-if="$route.name === 'OnboardingBrand'" @click="back">
          &larr; Back
        </button>
      </div>
      <nav class="flex flex-col items-center" aria-label="Progress">
        <ol class="flex items-center space-x-5">
          <li>
            <!-- Current -->
            <a v-if="$route.name === 'OnboardingCompany'" href="#" class="relative flex items-center justify-center" aria-current="step">
              <span class="absolute flex w-5 h-5 p-px" aria-hidden="true">
                <span class="w-full h-full bg-indigo-200 rounded-full"></span>
              </span>
              <span class="relative block w-2.5 h-2.5 bg-indigo-600 rounded-full" aria-hidden="true"></span>
              <span class="sr-only">Step 2</span>
            </a>
            <!-- Completed -->
            <a v-else href="#" class="block w-2.5 h-2.5 bg-indigo-600 rounded-full hover:bg-indigo-900">
              <span class="sr-only">Step 1</span>
            </a>
          </li>

          <li>
            <!-- Current -->
            <a v-if="$route.name === 'OnboardingBrand'" href="#" class="relative flex items-center justify-center" aria-current="step">
              <span class="absolute flex w-5 h-5 p-px" aria-hidden="true">
                <span class="w-full h-full bg-indigo-200 rounded-full"></span>
              </span>
              <span class="relative block w-2.5 h-2.5 bg-indigo-600 rounded-full" aria-hidden="true"></span>
              <span class="sr-only">Step 2</span>
            </a>
            <!-- Completed -->
            <a v-else-if="$route.name === 'OnboardingIntegrations'" href="#" class="block w-2.5 h-2.5 bg-indigo-600 rounded-full hover:bg-indigo-900">
              <span class="sr-only">Step 2</span>
            </a>
            <!-- Upcoming -->
            <a v-else href="#" class="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
              <span class="sr-only">Step 3</span>
            </a>
          </li>

          <li>
            <!-- Current -->
            <a v-if="$route.name === 'OnboardingIntegrations'" href="#" class="relative flex items-center justify-center" aria-current="step">
              <span class="absolute flex w-5 h-5 p-px" aria-hidden="true">
                <span class="w-full h-full bg-indigo-200 rounded-full"></span>
              </span>
              <span class="relative block w-2.5 h-2.5 bg-indigo-600 rounded-full" aria-hidden="true"></span>
              <span class="sr-only">Step 2</span>
            </a>
            <!-- Upcoming Step -->
            <a v-else href="#" class="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
              <span class="sr-only">Step 3</span>
            </a>
          </li>
        </ol>
        <p class="mt-4 text-sm font-medium text-gray-500">Step {{ step }} of 3</p>
      </nav>
      <div class="w-40">
        <router-link class="w-full btn btn-primary" v-if="$route.name === 'OnboardingIntegrations'" :to="{ name: 'Dashboard', params: { account: account.subdomain } }">
          Done &rarr;
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'OnboardingLayout',

  computed: {
    ...mapState(['user']),

    step () {
      const map = {
        'OnboardingCompany': 1,
        'OnboardingBrand': 2,
        'OnboardingIntegrations': 3
      }
      return map[this.$route.name]
    },

    account () {
      return this.user.accounts.find(account => account.subdomain == this.$route.params.account)
    }
  },

  data () {
    return {
      form: {
        name: '',
        country: '',
        timezone: '',
        currency: '',
        subdomain: '',
        color: 'black',
        telemetry_sync_enabled: false,
        order_sync_enabled: false,
        automations_enabled: false,
        notifications_enabled: false,
        track_area_activity: false,
        integration_webfleet: false,
        webfleet_account: '',
        webfleet_username: '',
        webfleet_password: ''
      }
    }
  },

  methods: {
    back () {
      if (this.$route.name === 'OnboardingBrand') {
        this.$router.push({ name: 'OnboardingCompany' })
      } else if (this.$route.name === 'OnboardingIntegrations') {
        this.$router.push({ name: 'OnboardingBrand' })
      }
    },

    async createAccount () {
      try {
        this.submitting = true
        const { data } = await this.$api.post(`accounts`, this.form)
        await this.$store.dispatch('syncUser', this)
        this.$router.push({ name: 'OnboardingIntegrations', params: { account: data.account.subdomain }})
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>